import type { ComputedRef, Ref } from "vue";
import { DSBaseListOption, DSOptionListModelValue } from "@/src/design_system/form_elements/option_list/types";
import {
  findOptionById,
  normalizeModelValue,
} from "@/src/design_system/form_elements/option_list/utils/optionListUtils";

interface UseSelectEnterArgs {
  isOpen: Ref<boolean>;
  activeOptionId: Ref<string | undefined>;
  flatOptions: ComputedRef<DSBaseListOption[]>;
  listId: string;
  optionListModelValue: Ref<DSOptionListModelValue>;
  multiple: ComputedRef<boolean>;
  closePopover: () => void;
  clearSearch: () => void;
  focusBaseInput: () => void;
  baseOnEnter: () => void;
}

interface UseSelectEnter {
  onEnter: () => void;
}

export const useSelectEnter = ({
  isOpen,
  activeOptionId,
  flatOptions,
  listId,
  optionListModelValue,
  multiple,
  closePopover,
  clearSearch,
  focusBaseInput,
  baseOnEnter,
}: UseSelectEnterArgs): UseSelectEnter => {
  const onEnter = () => {
    if (isOpen.value && activeOptionId.value) {
      const activeOption = findOptionById(listId, flatOptions.value, activeOptionId.value);
      if (!activeOption) {
        return;
      }

      if (multiple.value) {
        const currentValues = normalizeModelValue(optionListModelValue.value);
        optionListModelValue.value = currentValues.includes(activeOption.value)
          ? currentValues.filter(value => value !== activeOption.value)
          : [...currentValues, activeOption.value];
      } else {
        optionListModelValue.value = activeOption.value;
        closePopover();
        clearSearch();
        focusBaseInput();
        activeOptionId.value = undefined;
      }
      return;
    }
    baseOnEnter();
  };

  return { onEnter };
};
